import { useEffect, useState } from 'react'

// UTILS
import agentComponent from '../businesses/agent'
import { getHighest, getHighestGroup, thousandSeparator } from '../utils/helpers'

// COMPONENTS
import CommissionTable from '../components/salesRank/CommissionTable'
import AllGroup from '../components/salesRank/AllGroup'
import AgentDetailsModal from '../components/salesRank/AgentDetailsModal'
import FullPageLoader from '../components/Layout/FullPageLoader'
import Navbar from '../components/Layout/Navbar'
import Empty from '../components/Layout/Empty'
import FilterBar from '../components/salesRank/FilterBar'

const SalesRankPage = () => {
  const [year, setYear] = useState()
  const [listOfYear, setListOfYear] = useState()
  const [branches, setBranches] = useState()
  const [groups, setGroups] = useState()
  const [agents, setAgents] = useState()
  const [branchAgents, setBranchAgents] = useState()
  const [groupAgents, setGroupAgents] = useState()
  const [firstBranch, setFirstBranch] = useState()
  const [firstGroup, setFirstGroup] = useState()
  const [firstAgent, setFirstAgent] = useState()
  const [selectedBranch, setSelectedBranch] = useState()
  const [selectedGroup, setSelectedGroup] = useState()
  const [selectedBranchAgent, setSelectedBranchAgent] = useState()
  const [selectFirstGroup, setSelectFirstGroup] = useState(false)
  const [showTable, setShowTable] = useState()

  const [agentDetails, setAgentDetails] = useState({})
  const [openModal, setOpenModal] = useState(false)
  const [loading, setLoading] = useState(false)

  const selectBranch = (branch, group) => {
    if (groups?.length > 0 && branchAgents?.length > 0 && branch) {
      group ? setSelectFirstGroup(true) : setSelectFirstGroup(false)

      setShowTable()
      getGroupAgents(branch)

      const selectedBranch = groups.find(groups => groups.branch === branch)
      const selectedBranchAgent = branchAgents.find(item => item.branch === branch)

      setSelectedBranch(selectedBranch)
      setSelectedBranchAgent(selectedBranchAgent)
      setSelectedGroup()
    }
  }

  const selectGroup = (group) => {
    if (groupAgents?.length > 0 && group) {
      const selectedGroup = groupAgents.find(groups => groups.group === group)
      setSelectedGroup(selectedGroup)
      setShowTable('selectedGroup')
    }
  }

  const getGroupAgents = async branch => {
    const encodedBranch = encodeURIComponent(branch)
    const groupAgents = await agentComponent.rankingAgentByGroup(year, encodedBranch, 'detail')
    setGroupAgents(groupAgents)
  }

  const getAgentDetails = async (agent) => {
    const agentId = agent.id || agent._id
    const agentDetail = await agentComponent.getDownlineWithCommissionForYear(agentId, year)

    setAgentDetails({
        image: agentDetail.UserProfileImage,
        status: agentDetail.UserStatus,
        superior: agentDetail.superior,
        group: agentDetail.UserGroupName,
        name: agent.name,
        project: agent.project,
        subsale: agent.subsale,
        totalCommission: agent.totalCommission,
    })
    setOpenModal(true)
  }

  // INITIATE YEAR
  useState(() => {
    let currentYear = new Date().getFullYear();
    setYear(currentYear);

    let years = [currentYear];
    for (let idx = 0; idx < 4; idx++) years.unshift(--currentYear);
    setListOfYear(years);
  }, [])

  // FETCHING ALL DATA
  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      try {
        const [branchResponse, groupResponse, agentResponse, branchAgentResponse] = await Promise.all([
          agentComponent.rankingByBranch(year, 'detail'),
          agentComponent.rankingByGroup(year, 'detail'),
          agentComponent.rankingByAgent(year, 'detail'),
          agentComponent.rankingAgentByBranch(year, 'detail')
        ])
        
        setBranches(branchResponse)
        setGroups(groupResponse)
        setAgents(agentResponse)
        setBranchAgents(branchAgentResponse)

        setShowTable()
        setSelectedBranch()
        setSelectedGroup()
        setSelectedBranchAgent()
        setGroupAgents()
        setLoading(false)
      } catch (error) {}
    }

    fetchData()
  }, [year])

  // SET FIRST FOR EACH CATEGORY
  useEffect(() => {
    if (branches?.length > 0) {
      const firstBranch = getHighest(branches)
      setFirstBranch(firstBranch)
    }
    if (groups?.length > 0) {
      const firstGroup = getHighestGroup(groups)
      setFirstGroup(firstGroup)
    }
    if (agents?.length > 0) {
      const firstAgent = getHighest(agents)
      setFirstAgent(firstAgent)
    }
  }, [branches, groups, agents])


  useEffect(() => {
    if (selectFirstGroup) selectGroup(firstGroup?.group)
  }, [groupAgents])

  return (
    <div className='w-screen h-screen bg-secondary-light flex flex-col'>
      <Navbar
        title='Sales Ranking Report'
      />
      <FilterBar
        onHandleFilter={ setYear }
      />
      {/* <div className="w-full py-3.5 px-4 bg-primary text-white flex justify-between items-center relative">
        <p>Sales Ranking Report</p>

        <div className='absolute right-4 bottom-1/2 transform translate-y-1/2 w-[84px]'>
          <select onChange={e => setYear(e.target.value)} value={year} className="w-full py-1.5 font-medium px-3 rounded-xl text-xs text-gray-two cursor-pointer focus-visible:outline-none" aria-label="Default select example">
              {listOfYear?.map(group => {
                  return <option key={group} value={group} >{group}</option>
              })}
          </select>
        </div>
      </div> */}
      
      <div className='flex-1 w-full relative'>
        <div className='absolute top-0 left-0 w-full h-full overflow-auto hide-scrollbar md:p-5 p-3'>
          <div className='w-full h-full flex flex-col md:gap-4 gap-2'>
            <FullPageLoader loading={ loading } />
            {
              branches?.length > 0 ?
              <>
                <div className='flex md:flex-row flex-col md:gap-4 gap-2'>
                  <div className='md:w-1/2 grid md:grid-cols-3 md:gap-4 gap-2'>
                    {
                      firstBranch &&
                      <div onClick={ () => selectBranch(firstBranch.branch) } className='rounded-[10px] bg-white shadow-md md:py-5 py-1 md:px-1 px-2 flex md:flex-col items-center justify-between text-center cursor-pointer transition transform hover:scale-[1.01]'>
                        <div className='flex flex-col justify-center items-center md:mb-5'>
                          <div className='flex md:flex-col flex-col-reverse items-center'>
                            <p className='text-[10px] font-medium md:mb-0.5 text-primary'>Top Branch</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor" className="md:w-10 md:h-10 w-8 h-8 text-primary">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
                            </svg>
                          </div>

                          <p className='md:text-lg md:block hidden leading-none font-semibold text-gray-two mt-2'>{ firstBranch.branch }</p>
                        </div>

                        <div className='flex-1 flex flex-col items-center justify-between'>
                          <p className='text-xs md:hidden block leading-none font-semibold text-gray-two md:mt-2'>{ firstBranch.branch }</p>
                          <p className='md:text-2xl text-base font-semibold text-gray-one md:mb-2'>RM { thousandSeparator(firstBranch.totalCommission) }</p>
                          <p className='md:text-sm text-xs md:block hidden leading-[1.1] font-normal text-white mb-0'>{ firstBranch.branch }</p>
                        </div>
                      </div>
                    }
                    {
                      firstGroup &&
                      <div onClick={ () => selectBranch(firstGroup.branch, firstGroup.group) } className='rounded-[10px] bg-white shadow-md md:py-5 py-1 md:px-1 px-2 flex md:flex-col items-center justify-between text-center cursor-pointer transition transform hover:scale-[1.01]'>
                        <div className='flex flex-col justify-center items-center md:mb-5'>
                          <div className='flex md:flex-col flex-col-reverse items-center'>
                            <p className='text-[10px] font-medium md:mb-0.5 text-primary'>Top Group</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor" className="md:w-10 md:h-10 w-8 h-8 text-primary">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                            </svg>
                          </div>

                          <p className='md:text-lg md:block hidden leading-none font-semibold text-gray-two mt-2'>{ firstGroup.group }</p>
                        </div>

                        <div className='flex-1 flex flex-col items-center justify-between'>
                        <p className='text-xs md:hidden block leading-none font-semibold text-gray-two md:mt-2'>{ firstGroup.group }</p>
                          <p className='md:text-2xl text-base font-semibold text-gray-one md:mb-2'>RM { thousandSeparator(firstGroup.totalCommission) }</p>
                          <p className='md:text-sm text-xs leading-[1.1] font-normal text-gray-three mb-0'>{ firstGroup.branch }</p>
                        </div>
                      </div>
                    }
                    {
                      firstAgent &&
                      <div onClick={ () => setShowTable('agents') } className='rounded-[10px] bg-white shadow-md md:py-5 py-1 md:px-1 px-2 flex md:flex-col items-center justify-between text-center cursor-pointer transition transform hover:scale-[1.01]'>
                        <div className='flex flex-col justify-center items-center md:mb-5'>
                          <div className='flex md:flex-col flex-col-reverse items-center'>
                            <p className='text-[10px] font-medium md:mb-0.5 text-primary'>Top Agent</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor" className="md:w-10 md:h-10 w-8 h-8 text-primary">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                            </svg>
                          </div>
                          
                          <p className='md:text-lg md:block hidden leading-none font-semibold text-gray-two mt-2'>{ firstAgent.name }</p>
                        </div>

                        <div className='flex-1 flex flex-col items-center justify-between'>
                        <p className='text-xs md:hidden block leading-none font-semibold text-gray-two md:mt-2'>{ firstAgent.name }</p>
                          <p className='md:text-2xl text-base font-semibold text-gray-one md:mb-2'>RM { thousandSeparator(firstAgent.totalCommission) }</p>
                          <p className='md:text-sm text-xs leading-[1.1] font-normal text-gray-three mb-0'>{ firstAgent.branch }<span className='md:hidden'> - </span><span className='md:block inline-block font-medium'>{ firstAgent.group }</span></p>
                        </div>
                      </div>
                    }
                  </div>

                  <div className='md:w-1/2 md:min-h-[212px] min-h-[147px]'>
                    {
                      branches?.length > 0 &&
                      <CommissionTable entity={ branches } handleClick={ selectBranch } title='All Branches' />
                    }
                  </div>
                </div>

                <div className='flex-1 w-full flex flex-col md:gap-4 gap-2'>
                  {
                    (showTable !== 'agents' && selectedBranch) &&
                    <>
                      <p className='font-semibold text-gray-one'>Details of { selectedBranch.branch }</p>

                      <AllGroup selectedBranch={ selectedBranch } selectGroup={ selectGroup } />

                      {
                        (showTable === 'selectedGroup' && selectedGroup) &&
                        <div className='flex-1'>
                          <CommissionTable entity={ selectedGroup } handleClick={ getAgentDetails } title={ selectedGroup.group + ' Agents' } />
                        </div>
                      }

                      {
                        (showTable !== 'selectedGroup' && selectedBranchAgent && !selectFirstGroup) &&
                        <div className='flex-1'>
                          <CommissionTable entity={ selectedBranchAgent } handleClick={ getAgentDetails } title={ selectedBranchAgent.branch + ' Agents' } />
                        </div>
                      }
                    </>
                  }

                  {
                    (showTable === 'agents' && agents) &&
                    <div className='flex-1'>
                      <CommissionTable entity={ agents } handleClick={ getAgentDetails } title='All Agents' />
                    </div>
                  }
                </div>
              </> :
              <Empty />
            }
          </div>
        </div>
      </div>
      
      <AgentDetailsModal openModal={ openModal } setOpenModal={ setOpenModal } agent={ agentDetails } />
    </div>
  )
}

export default SalesRankPage